<div class="row g-1">
  @if (rendering?.fields?.BudgetbillTitle?.value) {
    <div class="col-12 col-sm-6">
      <p class="h6 mb-0" *scText="rendering?.fields?.BudgetbillTitle"></p>
      <p class="small" *scText="rendering?.fields?.ExcludingTax"></p>
    </div>
  }
  <div class="col-12 col-sm-6 text-center text-sm-end">
    @if (showBudgetBillBefore) {
      <p>
        <span *scText="rendering?.fields?.From"></span>
        &nbsp;
        <s class="fw-bold">{{
          offer.beforeDiscountExpectedMonthlyAmount | roundedCurrency
        }}</s>
        &nbsp;
        <span *scText="rendering?.fields?.To"></span>
      </p>
    }
    <p class="h4 mb-1">
      @if (rendering?.fields?.ShowCurrencyTextual?.value) {
        {{ offer?.expectedMonthlyAmount | currency: 'EUR' : '' : '1.0-0' }},-
        <span class="ps-1">euro</span>
      } @else {
        {{ offer.expectedMonthlyAmount | roundedCurrency }}
      }
      <span
        class="h5 fw-normal"
        *scText="rendering?.fields?.MonthSupLabel"
      ></span>
    </p>
    <p class="small mb-1">
      <span *scText="rendering?.fields?.YearlyCosts"></span>
      @if (rendering?.fields?.ShowOldvsNewAmount?.value) {
        <s>{{ offer.beforeDiscountExpectedYearlyAmount | roundedCurrency }}</s>
      }
      {{ offer.expectedYearlyAmount | roundedCurrency }}
    </p>
    @if (offer.budgetBillAmount) {
      <p class="small mb-1">
        <span *scText="rendering?.fields?.InstallmentAmountLabel"></span>&nbsp;
        <span class="h6">{{ offer.budgetBillAmount | roundedCurrency }}</span>
        <wl-tooltip
          class="ms-1"
          color="secondary"
          [style]="'light'"
          [tooltip]="{
            description: rendering?.fields?.BudgetbillSuggestionTooltip?.value,
          }"
        ></wl-tooltip>
      </p>
    }
  </div>
</div>
